module.exports = __webpack_public_path__ + "assets/img/00053.1a6cdee6.png";